/* eslint-disable @typescript-eslint/no-explicit-any */
import { Skeleton, VStack, HStack, Grid, Box, Button, css } from '@chakra-ui/react';
import { MainTemplate } from '../../templates/MainTemplate';
import { Label } from '../../components/atoms/Label';
import useIsMobile from '../../hooks/use-is-mobile';
import React, { useEffect } from 'react';
import { FaFrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import {
  BoxFatura,
  ContratosModal,
  ConexoesModal,
  CustomerCentralBoxes,
  ListPagination,
  DesbloqueioConfiancaConfirmModal,
  DesbloqueioConfiancaHubsoftModal,
  DesbloqueioMkModal,
  FaturaDetailCard,
  PixModal,
  RouterCredentialsModal,
} from './components';
import { useFaturaPage } from './hooks/useFaturaPage';

export function FaturaPage() {
  const nav = useNavigate();
  const isMobile = useIsMobile();

  const {
    colors,
    slug,
    customerCentralModule,
    integrationId,
    isLoading,
    IsLoadingFaturas,
    isFetchingContratos,
    isFetchingFaturas,
    perPage,
    contratosPage,
    faturasPage,
    contratosCount,
    faturasCount,
    contratosFailed,
    faturasFailed,
    contratosErrorMessage,
    faturasErrorMessage,
    contratosHasPrevious,
    contratosHasNext,
    faturasHasPrevious,
    faturasHasNext,
    goToPreviousContratos,
    goToNextContratos,
    goToPreviousFaturas,
    goToNextFaturas,
    isLoadingSegundaVia,
    hasPix,
    pix,
    pixError,
    isLoadingPix,
    isPixModalOpen,
    contratos,
    lastFatura,
    lastContrato,
    isModalOpen,
    isRouterCredentialsModalOpen,
    circuitIds,
    isLoadingCircuitIds,
    isSubmittingCredentials,
    containerRef,
    currentMonthRef,
    hasAutoScrolledRef,
    profile,
    showBoxesFaturaData,
    setIsModalOpen,
    handleChangeFatura,
    handleSegundaViaClick,
    handlePixClick,
    closePixModal,
    handleOpenLink,
    handleOpenWhatsApp,
    handleOpenWhatsAppPlan,
    executeDesbloqueioConfianca,
    desbloqueioHubsoft,
    handleOpenRouterCredentialsModal,
    onSubmitRouterCredentials,
    hasSegundaVia,
    closeContratosModal,
    closeRouterCredentialsModal,
    handleSelectContrato,
  } = useFaturaPage();

  const [isConexoesOpen, setIsConexoesOpen] = React.useState(false);
  const [isMkUnlockOpen, setIsMkUnlockOpen] = React.useState(false);
  const [isDesbloqueioConfirmOpen, setIsDesbloqueioConfirmOpen] = React.useState(false);
  const [isConfirmingDesbloqueio, setIsConfirmingDesbloqueio] = React.useState(false);
  const isMk = integrationId === 'mk';

  const handleDesbloqueioClick = () => {
    if (integrationId === 'hubsoft') {
      desbloqueioHubsoft.openModal();
      return;
    }
    if (isMk) {
      setIsMkUnlockOpen(true);
      return;
    }
    setIsDesbloqueioConfirmOpen(true);
  };

  const handleConfirmDesbloqueio = async () => {

    setIsConfirmingDesbloqueio(true);
    try {
      await executeDesbloqueioConfianca();
    } finally {
      setIsConfirmingDesbloqueio(false);
      setIsDesbloqueioConfirmOpen(false);
    }
  };

  useEffect(() => {
    hasAutoScrolledRef.current = false;
  }, [faturasPage, hasAutoScrolledRef]);

  useEffect(() => {
    if (!hasAutoScrolledRef.current && containerRef.current && currentMonthRef.current) {
      const container = containerRef.current;
      const item = currentMonthRef.current;
      const left = item.offsetLeft - (container.clientWidth / 2 - item.clientWidth / 2);
      container.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
      hasAutoScrolledRef.current = true;
    }
  }, [IsLoadingFaturas, showBoxesFaturaData]);

  useEffect(() => {
    if (!customerCentralModule) {
      nav(-1);
    }
  }, [customerCentralModule, nav]);

  const isEmpty = !IsLoadingFaturas && !isLoading && contratos.length === 0 && contratosCount === 0;
  const emptyMessage =
    contratosFailed || (faturasFailed && contratosCount === 0)
      ? contratosErrorMessage || faturasErrorMessage || 'Não foi possível consultar faturas. Entre em contato conosco'
      : 'Nenhuma fatura encontrada. Entre em contato conosco';

  return (
    <MainTemplate>
      <VStack align="self-start" marginBottom={100} spacing={5} width={{ base: '90%' }} paddingTop="20px">
        <Label>Central do Cliente</Label>

        {isEmpty ? (
          <VStack width="100%" spacing={5} paddingTop="50px">
            <FaFrown size="50px" color={colors.primaryColor} />
            <Label textAlign="center">{emptyMessage}</Label>
            <Button
              onClick={handleOpenWhatsApp}
              backgroundColor={colors.primaryColor}
              color="white"
              variant="solid"
            >
              Chamar no WhatsApp
            </Button>
          </VStack>
        ) : (
          <Grid width="100%" templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }} gap={6}>
            <VStack width="100%" spacing={6} overflow="hidden" align="stretch">
              <Label
                fontSize="14px"
                fontWeight="600"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="0.1em"
                fontFamily="Glory"
              >
                Contrato
              </Label>
              {isLoading || IsLoadingFaturas ? (
                <Box
                  borderRadius="lg"
                  backgroundColor="white"
                  boxShadow="2px 2px 6px 0px #0000002E"
                  padding="20px"
                  width="100%"
                  minHeight="200px"
                >
                  <VStack spacing={4} align="flex-start" width="100%">
                    <Skeleton height="24px" width="70%" borderRadius="md" />
                    <Skeleton height="20px" width="50%" borderRadius="md" />
                    <Skeleton height="20px" width="60%" borderRadius="md" />
                    <Skeleton height="30px" width="40%" borderRadius="md" />
                    <Skeleton height="16px" width="30%" borderRadius="md" />
                  </VStack>
                </Box>
              ) : (
                <FaturaDetailCard
                  lastFatura={lastFatura}
                  lastContrato={lastContrato}
                  colors={colors}
                  profileName={profile?.data?.fullName}
                  onBoletoClick={(url) => handleOpenLink(url)}
                />
              )}

              {(IsLoadingFaturas || showBoxesFaturaData.length > 0 || faturasCount > 0 || faturasFailed) && (
                <VStack spacing={2} align="flex-start" width="100%" overflow="hidden">
                  <Label
                    fontSize="14px"
                    fontWeight="600"
                    color="gray.500"
                    textTransform="uppercase"
                    letterSpacing="0.1em"
                    fontFamily="Glory"
                  >
                    Faturas
                  </Label>
                  <Box
                    whiteSpace="nowrap"
                    overflowX="auto"
                    width="100%"
                    css={
                      isMobile &&
                      css({
                        scrollbarWidth: 'auto',
                        '::-webkit-scrollbar': { display: 'block' },
                        WebkitOverflowScrolling: 'touch',
                        border: 'none',
                      })
                    }
                    ref={containerRef}
                  >
                    {faturasFailed ? (
                      <Label fontSize="sm" color="gray.500">
                        {faturasErrorMessage || 'Não foi possível consultar as faturas.'}
                      </Label>
                    ) : IsLoadingFaturas ? (
                      <HStack spacing={4} minWidth="fit-content" display="inline-flex">
                        {Array.from({ length: 3 }).map((_, i) => (
                          <Skeleton key={i} height="50px" width="100px" borderRadius="lg" />
                        ))}
                      </HStack>
                    ) : showBoxesFaturaData.length > 0 ? (
                      <HStack
                        paddingY="20px"
                        spacing={4}
                        minWidth="fit-content"
                        display="inline-flex"
                        opacity={isFetchingFaturas ? 0.6 : 1}
                      >
                        {showBoxesFaturaData.map(({ fatura, formattedTitle, isCurrentMonth, isActive }) => (
                          <Box
                            key={fatura.codigo_fatura}
                            ref={isCurrentMonth ? currentMonthRef : undefined}
                            display="inline-block"
                          >
                            <BoxFatura
                              onPress={() => handleChangeFatura(fatura)}
                              color={colors.primaryColor}
                              paga={fatura.fatura_paga}
                              active={isActive}
                              title={formattedTitle}
                              subtitle={new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              }).format(Number(fatura.valor))}
                            />
                          </Box>
                        ))}
                      </HStack>
                    ) : (
                      <Label fontSize="sm" color="gray.500">
                        Nenhuma fatura nesta página.
                      </Label>
                    )}
                  </Box>
                  {!faturasFailed && (
                    <ListPagination
                      page={faturasPage}
                      count={faturasCount}
                      perPage={perPage}
                      hasPrevious={faturasHasPrevious}
                      hasNext={faturasHasNext}
                      isLoading={isFetchingFaturas}
                      onPrevious={goToPreviousFaturas}
                      onNext={goToNextFaturas}
                      singular="fatura"
                      plural="faturas"
                      color={colors.primaryColor}
                    />
                  )}
                </VStack>
              )}
            </VStack>

            <VStack width="100%" spacing={5} align="flex-start" overflow="hidden">
              <Label
                fontSize="14px"
                fontWeight="600"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="0.1em"
                fontFamily="Glory"
              >
                Mais ferramentas
              </Label>
              {isLoading || isLoadingSegundaVia ? (
                Array.from({ length: 6 }).map((_, i) => (
                  <Skeleton key={i} height="100px" width="100%" borderRadius="lg" />
                ))
              ) : (
                <CustomerCentralBoxes
                  colors={colors}
                  slug={slug}
                  integrationId={integrationId}
                  lastContrato={lastContrato}
                  hasSegundaVia={!!hasSegundaVia}
                  isSegundaViaLoading={isLoadingSegundaVia}
                  hasPix={hasPix}
                  isPixLoading={isLoadingPix}
                  isFaturaPaga={!!lastFatura?.fatura_paga}
                  onPixClick={handlePixClick}
                  onSegundaViaClick={handleSegundaViaClick}
                  onContratosClick={() => setIsModalOpen(true)}
                  showConexoes={integrationId === 'mk'}
                  onConexoesClick={() => setIsConexoesOpen(true)}
                  onUpgradeClick={handleOpenWhatsAppPlan}
                  onWhatsAppClick={handleOpenWhatsAppPlan}
                  onDesbloqueioClick={handleDesbloqueioClick}
                  onRouterCredentialsClick={handleOpenRouterCredentialsModal}
                />
              )}
            </VStack>
          </Grid>
        )}

        <ContratosModal
          isOpen={isModalOpen}
          onClose={closeContratosModal}
          contratos={contratos}
          colors={colors}
          selectedContrato={lastContrato}
          onSelectContrato={handleSelectContrato}
          onBoletoClick={(url) => handleOpenLink(url)}
          count={contratosCount}
          page={contratosPage}
          perPage={perPage}
          hasPrevious={contratosHasPrevious}
          hasNext={contratosHasNext}
          isLoading={isFetchingContratos}
          isError={contratosFailed}
          errorMessage={contratosErrorMessage}
          onPrevious={goToPreviousContratos}
          onNext={goToNextContratos}
        />

        <PixModal
          isOpen={isPixModalOpen}
          onClose={closePixModal}
          isLoading={isLoadingPix}
          pix={pix}
          error={pixError}
          colors={colors}
        />

        <RouterCredentialsModal
          isOpen={isRouterCredentialsModalOpen}
          onClose={closeRouterCredentialsModal}
          onSubmit={onSubmitRouterCredentials}
          circuitIds={circuitIds}
          isLoadingCircuitIds={isLoadingCircuitIds}
          isSubmitting={isSubmittingCredentials}
          colors={colors}
        />

        <DesbloqueioConfiancaConfirmModal
          isOpen={isDesbloqueioConfirmOpen}
          onClose={() => setIsDesbloqueioConfirmOpen(false)}
          onConfirm={handleConfirmDesbloqueio}
          isSubmitting={isConfirmingDesbloqueio}
          colors={colors}
        />

        <ConexoesModal
          isOpen={isConexoesOpen}
          onClose={() => setIsConexoesOpen(false)}
          contrato={lastContrato}
          colors={colors}
        />

        <DesbloqueioMkModal
          isOpen={isMkUnlockOpen}
          onClose={() => setIsMkUnlockOpen(false)}
          colors={colors}
        />

        <DesbloqueioConfiancaHubsoftModal
          isOpen={desbloqueioHubsoft.isModalOpen}
          onClose={desbloqueioHubsoft.closeModal}
          onSubmit={async (data) => desbloqueioHubsoft.submitDesbloqueioHubsoft(data.qtd_dias)}
          isSubmitting={desbloqueioHubsoft.isSubmitting}
          colors={colors}
        />
      </VStack>
    </MainTemplate>
  );
}
